import { createSelector } from "@reduxjs/toolkit";

// Select the current language
export const selectCurrentLanguage = (state) => state.i18n.language;

// Select all available translations for the current language
export const selectTranslations = (state) => {
  const language = state.i18n.language;
  return state.i18n.translations[language] || {};
};

// Select loading state
export const selectI18nLoading = (state) => state.i18n.loading;

// Select error state
export const selectI18nError = (state) => state.i18n.error;

// Select supported languages
export const selectSupportedLanguages = (state) =>
  state.i18n.supportedLanguages;

// Create a memoized selector for translations
export const selectTranslation = createSelector(
  [selectTranslations, (_, key) => key],
  (translations, key) => {
    // Handle nested keys using dot notation
    if (!key) return "";

    const keys = key.split(".");
    let value = translations;

    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) break;
    }

    return value || key; // Return the key itself if translation is not found
  }
);

// Create a translation function for use in components
export const createTranslator = (state) => {
  return (key, params = {}) => {
    let translation = selectTranslation(state, key);

    // Replace parameters {param} with values
    if (typeof translation === "string" && Object.keys(params).length > 0) {
      Object.keys(params).forEach((param) => {
        translation = translation.replace(
          new RegExp(`{${param}}`, "g"),
          params[param]
        );
      });
    }

    return translation;
  };
};
